import { AI_CONFIG } from './constants'

const currentYear = new Date().getFullYear()

export interface MenuLink {
  id: string
  label: string
  icon?: string
  to: string
  name: string
  description: string
  special?: 'ai-assistant' | undefined
}
export interface CompanyLink {
  id: string
  name: string
  value: string
  icon: string
  to: string
  label: string
  description: string
}
export const companyLinks = (permalink: string): CompanyLink[] => [
  {
    id: 'overview',
    name: 'Overview',
    label: 'Overview',
    to: `/company/${permalink}`,
    value: 'overview',
    icon: 'i-heroicons-information-circle',
    description: 'Company overview and information'
  },
  {
    id: 'reviews',
    name: 'Reviews',
    label: 'Reviews',
    to: `/company/${permalink}/reviews`,
    value: 'reviews',
    icon: 'i-heroicons-star',
    description: 'Employee reviews and ratings'
  },
  {
    id: 'salaries',
    name: 'Salaries',
    label: 'Salaries',
    to: `/company/${permalink}/salaries`,
    value: 'salaries',
    icon: 'i-heroicons-currency-dollar',
    description: 'Salary data and compensation information'
  },
  {
    id: 'jobs',
    name: 'Jobs',
    label: 'Jobs',
    to: `/company/${permalink}/jobs`,
    value: 'jobs',
    icon: 'i-heroicons-briefcase',
    description: 'Open positions and job opportunities'
  },
  {
    id: 'dress-code',
    name: 'Dress Code',
    label: 'Dress Code',
    to: `/company/${permalink}/dress-code`,
    value: 'dress-code',
    icon: 'i-heroicons-user-circle',
    description: 'Company dress code policies'
  },
  {
    id: 'drug-test-policy',
    name: 'Drug Test',
    label: 'Drug Test',
    to: `/company/${permalink}/drug-test-policy`,
    value: 'drug-test-policy',
    icon: 'i-heroicons-beaker',
    description: 'Company drug testing policies'
  },
  {
    id: 'hiring-process',
    name: 'Hiring Process',
    label: 'Hiring Process',
    to: `/company/${permalink}/hiring-process`,
    value: 'hiring-process',
    icon: 'i-heroicons-clipboard-document-check',
    description: 'Company hiring process and interview tips'
  }
]
export const getMenuLinks = (country: string = 'us') => ({
  b2c: [
    {
      id: 'ai-assistant',
      label: `Ask ${AI_CONFIG.NAME}`,
      icon: 'ai-avatar',
      to: '#',
      name: `Ask ${AI_CONFIG.NAME} - ${AI_CONFIG.TITLE}`,
      description: 'Get personalized job search help and career guidance from our AI assistant',
      special: 'ai-assistant' as const
    },
    {
      id: 'jobs',
      label: 'Search Jobs',
      icon: 'i-heroicons-book-open',
      to: '/jobs',
      name: 'Search Jobs by Role and Location',
      description: 'Search Jobs by Role and Location'
    },
    ...(country === 'us'
      ? [{
        id: 'companies',
        label: 'Companies',
        icon: 'i-heroicons-book-open',
        to: '/company',
        name: 'Search Companies',
        description: 'Search Companies'
      }]
      : []),
    {
      id: 'ats-checker',
      label: 'Resume Checker',
      icon: 'i-heroicons-document-check',
      to: '/free-resume-checker',
      name: 'Free Resume Checker - Optimize for Applicant Tracking Systems',
      description: 'Analyze your resume against job descriptions and get an ATS compatibility score'
    },
    ...(country === 'us'
      ? [{
        id: 'tax-calculator',
        label: 'Tax Calculator',
        icon: 'i-heroicons-calculator',
        to: '/tax-calculator-usa',
        name: `Income Tax Calculator ${currentYear}`,
        description: 'Calculate your take-home pay after federal and state taxes'
      }]
      : []),
    {
      id: 'employers',
      label: 'Employers',
      icon: 'i-heroicons-user-group',
      to: '/employers',
      name: 'Real Programatic Job Advertising',
      description: 'Real Programatic Job Advertising'
    },
    {
      id: 'blog',
      label: 'Blog',
      icon: 'i-heroicons-pencil-square',
      to: '/blog',
      name: 'Blog',
      description: 'Blog'
    }
  ],
  b2b: [
    {
      id: 'ai-assistant',
      label: `Ask ${AI_CONFIG.NAME}`,
      icon: 'ai-avatar',
      to: '#',
      name: `Ask ${AI_CONFIG.NAME} - Your AI Assistant`,
      description: 'Get help with our platform, job posting, and recruitment questions',
      special: 'ai-assistant' as const
    },
    {
      id: 'jobs',
      label: 'Search Jobs',
      icon: 'i-heroicons-briefcase',
      to: '/jobs',
      name: 'Search Jobs by Role and Location',
      description: 'Search Jobs by Role and Location'
    },
    ...(country === 'us'
      ? [{
        id: 'companies',
        label: 'Companies',
        icon: 'i-heroicons-book-open',
        to: '/company',
        name: 'Search Companies',
        description: 'Search Companies'
      }]
      : []),
    {
      id: 'ats-checker',
      label: 'Resume Checker',
      icon: 'i-heroicons-document-check',
      to: '/free-resume-checker',
      name: 'Free Resume Checker - Optimize for Applicant Tracking Systems',
      description: 'Analyze your resume against job descriptions and get an ATS compatibility score'
    },
    ...(country === 'us'
      ? [{
        id: 'tax-calculator',
        label: 'Tax Calculator',
        icon: 'i-heroicons-calculator',
        to: '/tax-calculator-usa',
        name: `Income Tax Calculator ${currentYear}`,
        description: 'Calculate your take-home pay after federal and state taxes'
      }]
      : []),
    {
      id: 'industries',
      label: 'Industries',
      icon: 'i-heroicons-briefcase',
      to: '/employers/industries',
      name: 'Industries',
      description: 'Industries'
    },
    {
      id: 'about_us',
      label: 'About us',
      icon: 'i-heroicons-information-circle',
      to: '/employers/about',
      name: 'About us',
      description: 'About us'
    },
    {
      id: 'contact_us',
      label: 'Contact us',
      icon: 'i-heroicons-phone',
      to: '/employers/contact',
      name: 'Contact us',
      description: 'Contact us'
    },
    {
      id: 'blog',
      label: 'Blog',
      icon: 'i-heroicons-pencil-square',
      to: '/blog',
      name: 'Blog',
      description: 'Blog'
    }
  ]
})
export const menuLinks = getMenuLinks()